import { useEffect, useState } from "react";
import { HelperCard } from "../../components";
import { HelperCardLoader } from "../../components/loaders/productLoaders";
import cmsBlockService from "../../services/cmsBlockService";
import { useAppDispatch, useAppSelector } from "../../hooks";
import { selectHelpUsGrowSelector } from "../../store/cmsBlock/selector";
import { cmsBlockActionDispatch } from "../../store/cmsBlock/actions";
import { cmsBlockKeys } from "../../utils/constants";

const HelperCardLayout = () => {
  const [loading, setLoading] = useState(true);
  const helperCMSBlock = useAppSelector(selectHelpUsGrowSelector);

  const { setHelpUsGrow } = cmsBlockActionDispatch(useAppDispatch());

  useEffect(() => {
    cmsBlockService.setCMSBlocks(cmsBlockKeys.helpUsGrow, setHelpUsGrow, () =>
      setLoading(false)
    );
  }, []);

  return !loading ? <HelperCard data={helperCMSBlock} /> : <HelperCardLoader />;
};

export default HelperCardLayout;
